export default "__VITE_ASSET__fec7f3dd__"